import { gql } from 'apollo-angular';

export const GET_SUPPLIER_DASHBOARD_QUERY = gql`
  query GetSupplierDashboard {
    getSupplierDashboard {
      code
      status
      message
      data {
        totalSuppliers
        activeSuppliers
        pendingApprovals
      }
    }
  }
`;
